import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { EmptyState, Table } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { ContactStatisticBulkActions } from 'widgets/ContactStatistic'
import { useBroadcastDetailOneTimeContext } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime/context/context'
import { useContactStatisticColumns } from './useContactStatisticColumns'
import styles from './styles.module.scss'

export const BroadcastContactStatisticsTable = observer(() => {
  const {
    items,
    isNoData,
    total,
    loading,
    onPaginationModelChange,
    page,
    scrollToTOpTrigger,
    limit,
    tableStore,
    filter,
    search,
    onSuccessDelete,
    onOpenContactsDetails,
    contactsTagsModalStore,
    hasNoReplies,
    filtersListGroups,
    filtersList,
    loadingContactsFiltersByGroups,
  } = useBroadcastDetailOneTimeContext()
  const columns = useMemo(
    () => useContactStatisticColumns(filter, onOpenContactsDetails),
    [onOpenContactsDetails.disabled, filter]
  )

  const { selectedIds, bulkAllMode } = tableStore

  if (isNoData) {
    return (
      <EmptyState text={'No contacts found'} noIcon boxProps={{ flexGrow: 1, height: undefined }} />
    )
  }

  if (!loading && !items.length) {
    return <NoResultsFound boxProps={{ flexGrow: 1, height: undefined }} />
  }

  return (
    <div className={styles.wrapTable}>
      <Table
        ariaLabel={'BroadcastContactStatisticsTable'}
        virtualization
        columns={columns}
        rows={items}
        rowsCount={total}
        isLoading={loading}
        onChangePagination={onPaginationModelChange}
        initPage={page}
        limit={limit}
        startPaginationSize={10}
        sxTable={{ marginRight: 2, width: 'calc(100% - 16px)' }}
        scrollToTOpTrigger={scrollToTOpTrigger}
        withCheckbox
        store={tableStore}
        headerLeftContentProps={{
          actionsContent: (
            <ContactStatisticBulkActions
              contactsTagsModalStore={contactsTagsModalStore}
              selectedContactIds={selectedIds}
              filtersListGroups={filtersListGroups ?? undefined}
              filtersList={filtersList ?? undefined}
              bulkAll={bulkAllMode}
              isSelectionLoading={loadingContactsFiltersByGroups}
              search={search}
              withNewActions
              onSuccessDelete={onSuccessDelete}
            />
          ),
        }}
        withSelectAll={hasNoReplies}
      />
    </div>
  )
})
